<section class="page">
  <header>
    <div><p>Execution history</p><h2>Function runs</h2></div>
    <button type="button" [disabled]="loading" (click)="load()">
      <i class="pi pi-refresh" [class.pi-spin]="loading" aria-hidden="true"></i> Refresh
    </button>
  </header>

  <app-run-filters [value]="filters" [loading]="loading" (filtersChange)="applyFilters($event)" />

  <p class="error" *ngIf="error">{{ error }}</p>
  <div class="table-wrap" *ngIf="data?.items?.length; else state">
    <table>
      <colgroup><col class="index-column"><col class="service-column"><col class="function-column"><col class="type-column"><col class="url-column"><col class="trigger-column"><col class="priority-column"><col class="retry-column"><col class="date-column"><col class="date-column"><col class="duration-column"><col class="status-column"></colgroup>
      <thead><tr><th>#</th><th>Service</th><th>Function</th><th>Type</th><th>URL</th><th>Trigger</th><th>Priority</th><th>Retry attempt</th><th>Last run</th><th>Next run</th><th>Duration</th><th>Status</th></tr></thead>
      <tbody>
        <tr *ngFor="let run of data?.items; let index = index">
          <td>{{ rowIndex(index) }}</td>
          <td>{{ run.source }}</td>
          <td><a class="definition" [routerLink]="['/runs', run.id]" [title]="run.functionName">{{ run.functionName }}</a></td>
          <td>{{ run.functionType }}</td>
          <td><span class="truncate" [title]="run.url">{{ run.url }}</span></td>
          <td>{{ run.triggerSource }}</td>
          <td>{{ run.priority }}</td>
          <td>{{ run.attemptCount }} / {{ run.maxRetryCount }}</td>
          <td class="date-cell">{{ run.definitionLastRunAtUtc ? (run.definitionLastRunAtUtc | date:'medium') : '—' }}</td>
          <td class="date-cell">{{ run.definitionNextRunAtUtc ? (run.definitionNextRunAtUtc | date:'medium') : '—' }}</td>
          <td>{{ duration(run) }}</td>
          <td><span [class]="statusClass(run.status)">{{ run.status }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #state><div class="state" *ngIf="!error">{{ loading ? 'Loading function runs…' : 'No function runs found.' }}</div></ng-template>

  <app-pagination
    *ngIf="data"
    [page]="paging.page"
    [pageSize]="paging.pageSize"
    [totalCount]="data.totalCount"
    [loading]="loading"
    itemLabel="runs"
    (paginationChange)="changePagination($event)"
  />
</section>
